import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <p className="supLinesapce">What kind of influencer are you now? Is
                                                this the most suitable way to influence people who you currently
                                                work with? The six examples below form three pairs of styles to
                                                predict the kind of influencing behaviours that people will use.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>4</sup></a> When
                                                there is a situation that will potentially require influence,
                                                people are likely to adopt an influencing style that will land
                                                somewhere on one, if not more of the influencing styles. If you
                                                think back to some different work situations in your past, can
                                                you identify what kind of influencing style you were using? Bear
                                                in mind that, depending on the scenario, your influencing style
                                                may have changed (for example if you were tasked with managing a
                                                new project with a new team).</p>
                                            <p></p>

                                            <table className="ilead_v_sport tablesrink ilead_v_sport_new_task"
                                                   border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve" align="left" valign="center"
                                                        width="10%">Influencing Style
                                                    </th>
                                                    <th className=" green_curve1" align="left" valign="top"
                                                        width="40%">Strategies and Behaviours of Style
                                                    </th>


                                                </tr>
                                                <tr>
                                                    <td className="darkgreen uiheading" align="left"
                                                        valign="top" width="10%"><p>Bystander</p>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%"><p>Bystanders are unlikely to use any
                                                        influencing strategies. They are unlikely to make use of
                                                        a network of colleagues, instead being restricted to
                                                        mainly solitary activities. This strategy is most used
                                                        when the person is in a purely operational role, and has
                                                        few or no responsibilities outside of their own
                                                        workload. Additionally they have low access to key
                                                        resources and low power or expectation to influence
                                                        others.</p>
                                                    </td>

                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="10%">Shotgun
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%"><p>‘Shotguns’ are the opposite of
                                                        bystanders; they are likely to use every kind of
                                                        influencing strategy and use them regularly with great
                                                        abandon. ‘Shotguns’ are likely to have a workload that
                                                        requires them to work through a large network of people
                                                        and be motivated to have a lasting effect on them and
                                                        their actions. This is often due to their having great
                                                        responsibility or accountability for their actions and
                                                        the need to derive resources from many people.</p></td>


                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="10%">Strategist
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%"><p>Strategists are likely to use the
                                                        influencing strategies of ‘reason’, ‘assertion’ and,
                                                        less often, ‘partnership’. They have a high expectation
                                                        of being able to influence, mainly due to their previous
                                                        experience in a similar situation. Additionally, they
                                                        tend to be very independent, and not be overly concerned
                                                        with the needs of others, focusing on their own
                                                        workload.</p></td>


                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="10%">Opportunist
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%"><p>Opportunists are more prone to using
                                                        ‘courting favour’, ‘exchange’ and ‘coercion’ than the
                                                        other 3 strategies. They tend to have a low expectation
                                                        of the level of influence they are able to have, based
                                                        on previous experience in a similar situation. They are
                                                        dependent on others to help and also to be helped in
                                                        their own work.</p></td>


                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="10%">Collaborator
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%"><p>Collaborators use ‘exchange’, ‘courting
                                                        favour’, ‘reason’ and ‘partnership’ as their most common
                                                        strategies. They are aware of and act within the needs
                                                        of others due to the need to maintain cooperative
                                                        relationships. There is generally little need to
                                                        maintain and/or improve the behaviour or productivity of
                                                        others.</p></td>


                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="10%">Battler
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%"><p>Battlers will generally rely on the use
                                                        of ‘assertion’ or ‘coercion’ in order to influence
                                                        others. They normally use these strategies because they
                                                        have a need to drive change in people’s behaviour and
                                                        productivity due to the influencer having a large
                                                        strategic role. They normally do not have the need to
                                                        make goodwill gestures or be overly aware of the
                                                        feelings of others, and this leads to their use of more
                                                        forceful influencing strategies.</p></td>


                                                </tr>

                                                </tbody>
                                            </table>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">KNOW YOURSELF, KNOW THEM, ADAPT</span>
                                            </div>
                                            <p>Effective communicating and influencing requires a high level of
                                                personal awareness and knowing what impact you want to have on
                                                others when you’re trying to influence them.</p>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Three skills you should focus
                                                    on are:
                                                </div>
                                                <ul className="greenbullet-list horizontailul">

                                                    <li>Self-awareness</li>
                                                    <li>Awareness of others</li>
                                                    <li>Flexibility/adaptability</li>


                                                </ul>
                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }